import React, { Component } from 'react';
import PropTypes from 'prop-types'

import ModalLayout from "./shared/ModalLayout"

class CookieBanner extends Component {
	state = {
		showTOSModal: false
	}
	toggleModal = () => {
		this.setState(state => ({ showTOSModal: !state.showTOSModal }))
	}
	render() {
		let { t } = this.context
		let { showTOSModal } = this.state
		let { acceptCookiePolicy, lang } = this.props
		let TOSLinks = {
			fr: "2PACX-1vTqQl91zg6JVbd2mpXNfEgevERISji8RFUhtoMGrdKigGvD20uxcKBoeAPuWbLo0rq0OOrO7GnBepif",
			nl: "2PACX-1vQpkhYaccnS2ny0A7A6_hMk-2KEgQwuGq4-NZiTI-M_NEpTCVrZ609i7ZZROjrPNAGq1pA5EPpc-35r",
			en: "2PACX-1vQ2PYceNQQocuOHiI39abSUWLWh8h2bCXeTOatJCrNv_NGnt4DOJ-xr1GZDHU-ylM27EbjiB9nrFAXU"
		}
		return (
			<div className="CookieBanner">
				{showTOSModal &&
					<ModalLayout title={t('terms_of_service')} customClass="tos-modal" contentClass="g-doc-wrapper" closeModal={this.toggleModal}>
						<iframe title="tos" src={`https://docs.google.com/document/d/e/${TOSLinks[lang]}/pub?embedded=true`}></iframe>
					</ModalLayout>
				}
				<div className="description">{t('cookie_banner_text')}</div>
				<div className="buttons">
					<div className="more-info-button" onClick={this.toggleModal}>{t('cookie_policy_information_button')}</div>
					<div className="accept-button" onClick={acceptCookiePolicy}>{t('accept_cookie_policy_button')}</div>
				</div>
			</div>
		);
	}
}

CookieBanner.contextTypes = { t: PropTypes.func }
export default CookieBanner



// WEBPACK FOOTER //
// ./src/components/CookieBanner.js